import { createSelector } from '@reduxjs/toolkit';

import {
  DataSourceType,
  UNKNOWN_DATA_SOURCE_FAMILY,
} from 'src/constants/dataSourceTypeDescription';
import { dataSourceTypesSelector } from 'src/selectors/dataSourceTypes';
import { Connection } from 'src/store/connections/types';

export const dataSourceFamiliesByTypeSelector = (
  connection: Connection | null
) =>
  createSelector(
    dataSourceTypesSelector(connection),
    (dataSourceTypes): Record<DataSourceType, string> =>
      Object.entries(dataSourceTypes).reduce(
        (agg, type) => ({
          ...agg,
          [type[0]]: type[1]?.dataSourceFamily || UNKNOWN_DATA_SOURCE_FAMILY,
        }),
        {}
      )
  );
